import { useClientSelector } from "../../Redux/clientHooks.ts";
import { userIdSelector } from "../../Redux/clientSlice.ts";
import { useEffect, useState } from "react";
import { getAuthenticatedRequestHeaders } from "../../Auth/serverSessionApi.ts";
import type { SiteCardFrameStyle } from "../../Domain/CardFrameSettings.ts";

export interface SiteFeatures {
	shopEnabled: boolean;
	campaignEnabled: boolean;
	worldsEnabled: boolean;
	cardFrameStyle: SiteCardFrameStyle;
	rareStrength: number;
	legendaryStrength: number;
}

export const SITE_FEATURES_CHANGED_EVENT = "site-features-changed";

export const useSiteFeatures = () => {
	const userId = useClientSelector(userIdSelector);
	const [features, setFeatures] = useState<SiteFeatures | null>(null);
	useEffect(() => {
		if (!userId) {
			setFeatures(null);
			return;
		}
		const controller = new AbortController();
		const refresh = () => {
			void fetch("/api/site-features", {
				headers: getAuthenticatedRequestHeaders(),
				signal: controller.signal,
			})
				.then((response) => {
					if (!response.ok) throw new Error("Failed to load features");
					return response.json() as Promise<SiteFeatures>;
				})
				.then(setFeatures)
				.catch(() => undefined);
		};
		refresh();
		window.addEventListener(SITE_FEATURES_CHANGED_EVENT, refresh);
		return () => {
			controller.abort();
			window.removeEventListener(SITE_FEATURES_CHANGED_EVENT, refresh);
		};
	}, [userId]);
	return features;
};
